// extracted by mini-css-extract-plugin
module.exports = {"line":"dir_line__2lylE","mobileAppWrapper":"dir_mobileAppWrapper__BiRrn"};